import React from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardHeader from "@material-ui/core/CardHeader";
import IconButton from "@material-ui/core/IconButton";
import grey from "@material-ui/core/colors/grey";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import WorkIcon from "@material-ui/icons/Work";
import BuildIcon from "@material-ui/icons/Build";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import PersonIcon from "@material-ui/icons/Person";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import AddIcon from "@material-ui/icons/Add";
import {
    setDeletingTrack,
    setEditingTrack,
    openDeleteTrackModal,
    openEditTrackModal,
    openAddChildTrackModal,
    setCreateChildTrackParent
} from "../redux/actions";
import { connect } from "react-redux";
import Avatar from "@material-ui/core/Avatar";

const styles = theme => ({
    card: {
        maxWidth: 400,
        width: "100%"
    },
    media: {
        height: 0,
        paddingTop: "56.25%" // 16:9
    },
    actions: {
        display: "flex",
        bottom: "0px",
        position: "absolute"
    },
    expand: {
        transform: "rotate(0deg)",
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest
        }),
        marginLeft: "auto",
        [theme.breakpoints.up("sm")]: {
            marginRight: -8
        }
    },
    expandOpen: {
        transform: "rotate(180deg)"
    },
    avatar: {
        backgroundColor: grey[500]
    }
});

class TrackIDView extends React.Component {
    constructor(props) {
        super(props);
        this.state = { expanded: false, anchorEl: null, open: false };
    }

    handleExpandClick = () => {
        this.props.setShowChildren(!this.props.showChildren);
    };

    handleClose = () => {
        this.setState({
            ...this.state,
            anchorEl: null,
            open: false
        });
    };

    render() {
        const { classes } = this.props;
        const icon = {
            jobpack: <WorkIcon />,
            machines: <LocalShippingIcon />,
            equipment: <BuildIcon />,
            employees: <PersonIcon />
        };

        return (
            <Card
                className={`TrackIDView ${
                    this.props.type === "jobpack" ? "TrackIDView-parent" : "TrackIDView-child"
                }`}
            >
                <CardHeader
                    avatar={<Avatar>{icon[this.props.type]}</Avatar>}
                    action={
                        <IconButton>
                            <MoreVertIcon
                                onClick={event => {
                                    this.setState({
                                        ...this.state,
                                        anchorEl: event.currentTarget,
                                        open: true
                                    });
                                }}
                            />
                        </IconButton>
                    }
                    title={this.props.name}
                    subheader=""
                />
                <Menu
                    id="render-props-menu"
                    anchorEl={this.state.anchorEl}
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    <MenuItem
                        onClick={() => {
                            this.handleClose();
                            this.props.setEditingTrack(
                                this.props.parentTrackIndex,
                                this.props.childTrackIndex
                            );
                            this.props.openEditTrackModal();
                        }}
                    >
                        Edit
                    </MenuItem>
                    <MenuItem
                        onClick={() => {
                            this.handleClose();
                            this.props.setDeletingTrack(
                                this.props.parentTrackIndex,
                                this.props.childTrackIndex
                            );
                            this.props.openDeleteTrackModal();
                        }}
                    >
                        Delete
                    </MenuItem>
                </Menu>

                <CardContent>
                    <Typography component="p">
                        {/* This impressive paella is a perfect party dish and a fun meal to cook
                        together with your guests. Add 1 cup of frozen peas along with the mussels,
                        if you like. */}
                    </Typography>
                </CardContent>

                {this.props.type === "jobpack" ? (
                    <CardActions className={classes.actions}>
                        <div style={{ flex: 1 }}>
                            <IconButton
                                className={classnames(classes.expand, {
                                    [classes.expandOpen]: !this.props.showChildren
                                })}
                                onClick={this.handleExpandClick}
                                aria-expanded={this.props.showChildren}
                                aria-label="Show more"
                            >
                                <ExpandMoreIcon />
                            </IconButton>
                        </div>

                        <IconButton
                            aria-label="Add"
                            className={classes.extendedIcon}
                            style={{ marginLeft: "130px" }}
                            mini="true"
                            onClick={() => {
                                this.props.openAddChildTrackModal();
                                this.props.setCreateChildTrackParent(this.props.parentTrackIndex);
                            }}
                        >
                            <AddIcon />
                        </IconButton>
                    </CardActions>
                ) : null}
            </Card>
        );
    }
}

export default withStyles(styles)(
    connect(
        store => {
            return {};
        },
        {
            setDeletingTrack,
            setEditingTrack,
            openDeleteTrackModal,
            openEditTrackModal,
            openAddChildTrackModal,
            setCreateChildTrackParent
        }
    )(TrackIDView)
);
